module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbBAMAAACQOIJYAAAAMFBMVEUAAAD3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSu2a2yBAAAAD3RSTlMAdxHM7qqIMyLdRJlmVbvFUNfrAAAApUlEQVQY02OAACYGZFCLwstG4U1B5nD8v4DEY/wfgMRj/v8Jidf//w8ST/7/VySe/f//CmCGIAj8//9/I4hmKP6PAB8ZGPLhnJ8FDAxc/jBeEEinKpTjAzMfBD43QHjsYF4A3M0gsAHuZhBwgLsZBH7B3fzf7f//bwg3K6z8/xPKe/9FgIEp/n8BJPT+W4CM8hcA83g+gqliAzDFtgCiIQkWzjAaAF4EaHkAGJXiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/star.png
// module id = 867
// module chunks = 11